import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Col, Card, Tooltip, message, Icon, Avatar, Row, Tag } from 'antd';

const { Meta } = Card;

class Course extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // newCourse: false
    };

    this.handleClick = this.handleClick.bind(this);
  }

  // componentDidMount() {
  //   var nowDate = moment(Date.now())
  //   var thenDate = moment(this.props.course.created)
  //   var diffDate = nowDate.diff(thenDate, 'days')
  //   if(diffDate < 3) {
  //     this.setState({
  //       newCourse: true
  //     })
  //   } 
  // }

  checkHours = (num) => {
    let hours = Math.floor(num / 3600);  
    return hours
  }

  outputDur = (num) => {
    let hours = Math.floor(num / 3600); 
    let text = ''
    switch (hours) {
      case 0:
        text = ' mins'
        break;
      case 1:
        text = ' hour'
        break;
      default:
        text = ' hours'
    } 
    return text
  }

  handleClick() {
    // if (!this.props.auth.uid) {
    //   message.info('You need to login first.');
    // }
    this.props.history.push(`/courses/${this.props.course.slug}`);
  }
  render() {
    const { course } = this.props;
    // const { newCourse } = this.state
    // console.log(newCourse)
    return (
      <Col className="gutter-row course-card-main" xs={24} sm={24} md={12} lg={6}>
        <Card hoverable
          cover={<img alt="" src={course.image} />} className="course-card" onClick={() => this.handleClick()}>
          <Meta title={course.title} />
          {course.isNewCourse &&
            <div className="upflag">
              New
          </div>}
          {/* <div className="reviews">
            <Icon type="star" theme="filled" className="review-icon" />
            <Icon type="star" theme="filled" className="review-icon" />
            <Icon type="star" theme="filled" className="review-icon" />
            <Icon type="star" theme="filled" className="review-icon" />
            <Icon type="star" />
            <span className="reviews-text">(80 reviews)</span>
          </div> */}
          <div className="timing">
            <Icon type="clock-circle" className="timing-icon" />
            <span className="timing-text">
            {
            this.checkHours(course.duration) ? moment.utc(course.duration*1000).format('h') : moment.utc(course.duration*1000).format('m')
            } 
            {
              this.outputDur(course.duration)
            }
            </span>
          </div>
          <div className="tags">
            {
              course.tags.map(tag => (
                <Tag color="#108ee9" key={tag}>{tag}</Tag>
              ))
            }
          </div>
        </Card>
      </Col>
    );
  }
}
const mapStateToProps = state => ({
  auth: state.firebase.auth
});
const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(Course);
